import type { FormEvent } from "react";

import { REQUIRED_MESSAGE, useDialogForm } from "@/ds";
import {
  EDIT_USER_FORM_ID,
  ROLES_EMPTY_MESSAGE,
  ROLES_ERROR_MESSAGE,
} from "./edit-user-dialog.constants";
import type {
  EditUserDialogProps,
  EditUserDialogViewModel,
  EditUserValues,
} from "./types-edit-user-dialog";
import { buildUserContato } from "../../users.utils";

function validate({ papelId }: EditUserValues) {
  return papelId ? {} : { papelId: REQUIRED_MESSAGE };
}

/**
 * Formulário de edição (HU 721): o perfil é obrigatório e validado em tela antes de qualquer requisição; só ele sai do
 * formulário, porque a identidade vem do diretório corporativo e nunca é enviada (RN03).
 */
export function useEditUserDialog({
  user,
  roles,
  onSubmit,
  onCancel,
}: EditUserDialogProps): EditUserDialogViewModel {
  const form = useDialogForm<EditUserValues>({
    initial: { papelId: user.papelId },
    validate,
    onSubmit: ({ papelId }) => onSubmit({ papelId }),
  });

  return {
    formId: EDIT_USER_FORM_ID,
    contato: buildUserContato(user, "edit-user"),
    perfil: {
      value: form.values.papelId,
      error: form.errors.papelId ?? null,
      options: roles.options,
      emptyMessage: roles.hasError ? ROLES_ERROR_MESSAGE : ROLES_EMPTY_MESSAGE,
      isDisabled: form.isSubmitting || roles.isLoading,
      escolher: (papelId) => form.setValue("papelId", papelId),
    },
    isSubmitting: form.isSubmitting,
    enviar: (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      void form.submit();
    },
    cancelar: onCancel,
  };
}
